import { render, staticRenderFns } from "./FamilyUserProfile.vue?vue&type=template&id=713aa57a"
import script from "./FamilyUserProfile.vue?vue&type=script&lang=js"
export * from "./FamilyUserProfile.vue?vue&type=script&lang=js"
import style0 from "./FamilyUserProfile.vue?vue&type=style&index=0&id=713aa57a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports